import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { ChevronRightIcon, OutrightEventLink, StatusAndDateWrapper } from './HomepageHeroWidgetNFLOutrights.style';
import { EventListGroupEventItemType } from 'src_common/common/websocket2/modelsApi/EventsCollectionQuery';
import { slug } from 'src/utils/deburr';
import { EventStatusAndDate } from 'src/domains/sportsbook/webview/components/events/row/StatusAndDate';

interface PropsType {
    smallEvent: EventListGroupEventItemType;
}

export const HomepageHeroWidgetNFLOutrights = observer(
    'HomepageHeroWidgetNFLOutrights',
    ({ smallEvent }: PropsType): JSX.Element | null => {
        return (
            <OutrightEventLink to={{ name: 'event', id: smallEvent.id2.toOldId(), slug: slug(smallEvent.name) }}>
                {smallEvent.name}
                <StatusAndDateWrapper>
                    <EventStatusAndDate
                        dateFormat='todayAndTomorrow'
                        marketType='6pack'
                        smallEvent={smallEvent}
                    />
                </StatusAndDateWrapper>
                <ChevronRightIcon position='right' />
            </OutrightEventLink>
        );
    }
);
